import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';
import { createPortal } from 'react-dom';

type HostApi = {
  setHost: (el: HTMLElement | null) => void;
  host: HTMLElement | null;
};

const AppHeaderActionsHostContext = createContext<HostApi | null>(null);

export function AppHeaderActionsProvider({ children }: { children: ReactNode }) {
  const [host, setHost] = useState<HTMLElement | null>(null);
  const value = useMemo(() => ({ host, setHost }), [host]);
  return (
    <AppHeaderActionsHostContext.Provider value={value}>{children}</AppHeaderActionsHostContext.Provider>
  );
}

/** Contenedor en el header de la app donde se montan las acciones de la pantalla. */
export function AppHeaderActionsHost({ className }: { className?: string }) {
  const api = useContext(AppHeaderActionsHostContext);
  const setHost = api?.setHost;
  const ref = useCallback(
    (el: HTMLDivElement | null) => {
      setHost?.(el);
    },
    [setHost]
  );
  return <div className={className} ref={ref} />;
}

/** Montá acciones en el header general (portal). */
export function AppHeaderActions({ children }: { children: ReactNode }) {
  const api = useContext(AppHeaderActionsHostContext);
  if (!api?.host) return null;
  return createPortal(children, api.host);
}
